import { memo, useCallback } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import { BinIcon } from '../../../../components/icon/Icon';
import {
    WatchVideoLaterImageContainer,
    WatchVideoLaterMenuTitleStyled,
    WatchVideoLaterTooltipFooterStyled,
    WatchVideoLaterTooltipStyled,
} from './styled/WatchVideoLaterTooltipStyled';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getIsShowWatchMoreVideosLaterTooltip } from '../../tutorialsSelectors';
import { useHideTooltipByTimeout } from './watchVideoLaterTooltipHooks';
import { showWatchMoreVideosLaterTooltipAction } from '../../tutorialsActions';
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext.js";

const WatchVideoLaterTooltip = memo(({
    children,
    isShowWatchMoreVideosLaterTooltip,
    showWatchMoreVideosLaterTooltipAction,
}) => {
    const {getLangPath} = useLangContext();
    const handleTooltipHide = useCallback(
            () => showWatchMoreVideosLaterTooltipAction(false),
            [showWatchMoreVideosLaterTooltipAction],
    );
    useHideTooltipByTimeout({isShow: isShowWatchMoreVideosLaterTooltip, handleTooltipHide, timeout: 10000});
    return (
            <OverlayTrigger
                    show={isShowWatchMoreVideosLaterTooltip}
                    placement="bottom"
                    overlay={
                        <Popover>
                            <WatchVideoLaterTooltipStyled>
                                <WatchVideoLaterImageContainer/>
                                <WatchVideoLaterMenuTitleStyled>
                                    <BinIcon
                                            name="IcGraduationCap"
                                            style={{fontSize: '16px', fill: '#B9BFDF', marginRight: '8px'}}
                                    />
                                    {getLangPath('menu.tutorials')}
                                </WatchVideoLaterMenuTitleStyled>
                                <WatchVideoLaterTooltipFooterStyled>
                                    {getLangPath('video_tutorial.watch_later.tooltip')}
                                </WatchVideoLaterTooltipFooterStyled>
                            </WatchVideoLaterTooltipStyled>
                        </Popover>
                    }
            >
                <div>{children}</div>
            </OverlayTrigger>
    );
});

const mapStateToProps = createStructuredSelector({
    isShowWatchMoreVideosLaterTooltip: getIsShowWatchMoreVideosLaterTooltip,
});

const mapDispatchToProps = (dispatch) => ({
    showWatchMoreVideosLaterTooltipAction: (payload) => dispatch(showWatchMoreVideosLaterTooltipAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WatchVideoLaterTooltip);
